import type { ReactNode } from 'react'

import {
  SettingsFieldDescription,
  SettingsFieldLabel,
} from '@/components/settings/settings-field-copy'
import { SettingsRowFrame } from '@/components/settings/settings-row-frame'
import { cn } from '@/lib/utils'

const MATRIX_INNER =
  'grid min-h-16 grid-cols-[1fr_auto_auto] items-center gap-x-6 py-4'

export type SettingsMatrixColumn = {
  key: string
  label: string
  className?: string
}

export function SettingsMatrixHeader({
  leadingLabel,
  columns,
}: {
  leadingLabel: string
  columns: SettingsMatrixColumn[]
}) {
  return (
    <SettingsRowFrame showDivider innerClassName={MATRIX_INNER}>
      <SettingsFieldLabel className="text-muted-foreground">{leadingLabel}</SettingsFieldLabel>
      {columns.map((column) => (
        <span
          key={column.key}
          className={cn(
            'text-center text-[13px] font-medium text-muted-foreground',
            column.className ?? 'w-12',
          )}
        >
          {column.label}
        </span>
      ))}
    </SettingsRowFrame>
  )
}

export function SettingsMatrixRow({
  label,
  description,
  children,
  showDivider = true,
}: {
  label: string
  description?: string
  children: ReactNode
  showDivider?: boolean
}) {
  return (
    <SettingsRowFrame showDivider={showDivider} innerClassName={MATRIX_INNER}>
      <div className="min-w-0">
        <SettingsFieldLabel>{label}</SettingsFieldLabel>
        {description ? <SettingsFieldDescription>{description}</SettingsFieldDescription> : null}
      </div>
      {children}
    </SettingsRowFrame>
  )
}

export function SettingsMatrixCell({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <div className={cn('flex w-12 justify-center', className)}>{children}</div>
}
